export default "__VITE_ASSET__CjOQMpVr__"